var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"margin":"0"},domProps:{"innerHTML":_vm._s(_vm.privacy)}},[_vm._v("哈哈哈哈")])
}
var staticRenderFns = []

export { render, staticRenderFns }